<template>
  <div>
    <ReparoVeiculoForm :formData="formData" :dominios="dominios" />

    <ReparoVeiculoDetalhesForm :formData="formData" :dominios="dominios" />

    <ProcessoDatasForm :formData="formData" :dominios="dominios" />

    <FotosDocumentos
      :formData="formData"
      :arquivos="formData.arquivosReparoVeiculo"
      :idReferente="idReferenteReparo"
    />

    <CustoEvento :formData="formData" :dominios="dominios" />
  </div>
</template>

<script>
import CustoEvento from './components/CustoEventoForm.vue';
import FotosDocumentos from './../../../shared/components/FotosDocumentos.vue';
import ProcessoDatasForm from './../../../shared/components/ProcessoDatasForm.vue';
import ReparoVeiculoDetalhesForm from './../../../shared/components/ReparoVeiculoDetalhesForm.vue';
import ReparoVeiculoForm from './components/ReparoVeiculoForm.vue';
import { FOTO_REFERENTE_REPARO } from './../../../shared/const';

export default {
  props: ['formData', 'dominios'],
  components: {
    CustoEvento,
    FotosDocumentos,
    ProcessoDatasForm,
    ReparoVeiculoDetalhesForm,
    ReparoVeiculoForm,
  },
  data() {
    return {
      idReferenteReparo: FOTO_REFERENTE_REPARO,
    };
  },
};
</script>
